import { Component } from '@angular/core';

@Component({
  selector: 'wilson-legends',
  templateUrl: './legends.component.html',
  styleUrls: ['./legends.component.scss'],
  standalone: false,
})
export class LegendsComponent {}
